const listeners = new Set();

let state = {
  held: false,
  message: "",
  holdReason: "",
  heldUntil: null,
};

function emit() {
  listeners.forEach((fn) => {
    try {
      fn(state);
    } catch {
      /* ignore */
    }
  });
}

export function getFiatHoldState() {
  return state;
}

export function noteFiatHold(err) {
  if (!err || err.code !== "FIAT_SERVICE_HELD") return;
  const data = err.data && typeof err.data === "object" ? err.data : {};
  state = {
    held: true,
    message: err.message || "Fiat service is temporarily unavailable",
    holdReason: data.hold_reason ? String(data.hold_reason) : "",
    heldUntil: data.held_until || null,
  };
  emit();
}

export function clearFiatHold() {
  if (!state.held) return;
  state = { held: false, message: "", holdReason: "", heldUntil: null };
  emit();
}

export function subscribeFiatHold(fn) {
  listeners.add(fn);
  fn(state);
  return () => listeners.delete(fn);
}
